export default __webpack_public_path__ + "static/media/icone-gravida.c9d23b05.svg";